import { Button } from "primereact/button";
import { Timeline } from "primereact/timeline";
import { useNavigate } from "react-router-dom";
import MeaStudentResult from "../../../../components/MeaStudentResult";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import memberRegistrationsAPI from "../../../../services/member_registrations";
import "./MemberRegistrationsTimelineComponent.css";

const MemberRegistrationsTimelineComponent = ({
  memberId,
  schoolId,
  fallbackStudentId,
  disableNavigation = false,
}) => {
  const navigate = useNavigate();
  const registrationsQuery = memberRegistrationsAPI.useGetList(
    schoolId,
    "",
    "",
    memberId,
    1,
    200
  );
  const registrationsHistory = registrationsQuery?.data?.data || [];

  if (registrationsQuery?.isLoading) {
    return <div className="text-center text-500 py-4">Chargement de l'historique...</div>;
  }

  if (registrationsHistory.length === 0) {
    return <div className="text-center text-500 py-4">Aucun historique d'inscription</div>;
  }

  return (
    <Timeline
      value={registrationsHistory}
      className="w-full registration-history-timeline"
      pt={{
        opposite: {
          style: {
            flex: "0 0 33.3333%",
            maxWidth: "33.3333%",
          },
        },
        content: {
          style: {
            flex: "0 0 66.6667%",
            maxWidth: "66.6667%",
          },
        },
      }}
      marker={() => (
        <span className="inline-flex align-items-center justify-content-center border-circle bg-primary text-white w-2rem h-2rem">
          <i className="pi pi-book" />
        </span>
      )}
      opposite={(item) => (
        <div className="registration-history-opposite text-right pr-4">
          {disableNavigation ? (
            <div className="text-900 font-medium text-base mb-2">
              {item?.training?.name || "-"}
            </div>
          ) : (
            <Button
              type="button"
              label={item?.training?.name || "-"}
              className="p-button-text p-button-sm p-0 text-right justify-content-end text-900 font-medium text-base mb-2"
              onClick={() => {
                const candidateId = item?.student_id || item?.student?.id || item?.id || fallbackStudentId;
                if (!candidateId) return;
                navigate(
                  `/school/${schoolId}/admin/registrations/${item?.training_id || item?.training?.id}/candidates/${candidateId}`
                );
              }}
            />
          )}
          <div className="text-900"><MeaStudentStatus2 student={item} /></div>
        </div>
      )}
      content={(item) => (
        <div className="registration-history-content pl-4">
          <div className="surface-50 border-1 surface-border border-round p-3 mb-3">
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className="text-500 text-sm">Niveau</div>
                <div className="text-900 font-medium">{item?.level?.name || "-"}</div>
              </div>
              <div className="col-12 md:col-6">
                <div className="text-500 text-sm">Classe</div>
                <div className="text-900 font-medium">{item?.classe?.name || "-"}</div>
              </div>
              <div className="col-12 md:col-6">
                <div className="text-500 text-sm">Résultat</div>
                <div className="text-900"><MeaStudentResult student={item} /></div>
              </div>
              <div className="col-12 md:col-12">
                <div className="text-500 text-sm">Appréciation générale</div>
                <div className="text-900 font-medium">{item?.result_observation || "-"}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default MemberRegistrationsTimelineComponent;
